import React from 'react';
import styles from '../../css/Part5.module.css';

const FeatureItem = ({ iconSrc, text }) => (
  <div className={styles.featureItem}>
    <img src={iconSrc} alt="" className={styles.featureIcon} />
    <div className={styles.featureText}>{text}</div>
  </div>
);

const features = [
  { iconSrc: "images/icons/Group 50.png", text: "Pay for Natural Spending" },
  { iconSrc: "images/icons/Group 50 (1).png", text: "Earn from your ecommunity spending" },
  { iconSrc: "images/icons/Group 50 (2).png", text: "Enjoy Hyper Rewards" }
];

function LoyaltyProgram() {
  return (
    <main className={styles.container}>
      <div className={styles.content}>
        <div className={styles.twoColumnLayout}>
          <section className={styles.leftColumn}>
            <div className={styles.programInfo}>
              <h1 className={styles.programHeadline}>
                Our User's Secret To Community Rewards And Happiness!
              </h1>
              <div className={styles.featureList}>
                {features.map((feature, index) => (
                  <FeatureItem key={index} iconSrc={feature.iconSrc} text={feature.text} />
                ))}
              </div>
            </div>
          </section>
          <section className={styles.rightColumn}>
            <div className={styles.videoWrapper}>
              <video className={styles.backgroundvideo} controls>
                <source src="images/video/fone.mp4" type="video/mp4" />
                  Your browser does not support the video tag.
              </video>
            </div>
          </section>
        </div>
      </div>

      <h2 className={styles.partnerHeadline}>
        Your Natural Spending Companion | <br></br>Your Loyal Business Companion
      </h2>
      <div className={styles.partnerDescription}>
        <img src="images/background/Beourpartner.png" alt="" className={styles.partnerBackgroundImage} />
        <p className={styles.partnertext}>
          User can use FoneApp to pay for everything, from your daily groceries, online shopping sprees, fuel your car, to gathering with friends at the best hotpot in town or your favourite hangout sport.
        </p>
     
        <p className={styles.partnertext}>Be part of the rewarding ecosystem, giving a reason for customers to spend with your brand</p>
      </div>
    </main>
  );
}

export default LoyaltyProgram;